import { safeDefineElement } from '@/scripts/core/global'
import { ActivateCustomer } from '@/scripts/optional/activate-customer'

safeDefineElement(ActivateCustomer)
